interface ToastProps {
  message: string;
}

export default function Toast({ message }: ToastProps) {
  if (!message) return null;
  return (
    <div className="fixed left-1/2 bottom-8 -translate-x-1/2 z-[80] px-5 py-3 rounded-full bg-foreground-950 text-background-50 text-sm shadow-lg animate-fade-up">
      {message}
    </div>
  );
}